import { Injectable } from '@angular/core';
import { sgConfig } from '../../config/sg.config';
import { frConfig } from '../../config/fr.config';
import { auConfig } from '../../config/au.config';
import { essConfig } from '../../config/ess.config';
import { cnConfig } from '../../config/cn.config';
import { hkConfig } from '../../config/hk.config';
import { defaultConfig } from '../../config/default.config';
import { dfamConfig } from '../../config/dfam.config';
import { dmaasConfig } from '../../config/dmaas.config';
import { jpcorpConfig } from '../../config/jpcorp.config';
import { Tenant } from '../types/tenant.enum';
import { ConfigStateService } from '../../app/config/config-state.service';

/**
 * An interface that makes it possible to easily mock time/timeouts in tests.
 * The angular/zone setTimeout mocking with jasmine.clock().install() etc is
 * too unreliable to use.
 */
@Injectable()
export class TenantConfigService {
  private tenantConfig;
  constructor(private configStateService: ConfigStateService) {
    this.initConfig();
  }
  
  initConfig() {
    switch (this.configStateService.tenant) {
      case Tenant.SG:
        this.tenantConfig = Object.assign(defaultConfig, sgConfig);
        return;
      case Tenant.AU:
        this.tenantConfig = Object.assign(defaultConfig, auConfig);
        return;      
      case Tenant.ESS:
        this.tenantConfig = Object.assign(defaultConfig, essConfig);
        return;      
      case Tenant.CN:
        this.tenantConfig = Object.assign(defaultConfig, cnConfig);
        return;
      case Tenant.HK:
        this.tenantConfig = Object.assign(defaultConfig, hkConfig);
        return;
      case Tenant.FR:
        this.tenantConfig = Object.assign(defaultConfig, frConfig);
        return;
      case Tenant.DMAAS:
        this.tenantConfig = Object.assign(defaultConfig, dmaasConfig);
        return;
      case Tenant.DFAM:
        this.tenantConfig = Object.assign(defaultConfig, dfamConfig);
        return;
      case Tenant.JPCORP:
        this.tenantConfig = Object.assign(defaultConfig, jpcorpConfig);
        return;
      default:
        this.tenantConfig = defaultConfig;
        return;
    }
  }
  
  get config() {
    return this.tenantConfig;
  }

  static getTaxpayerAliasPaths() {
    return [
      defaultConfig.taxpayerAliasPath,
      dfamConfig.taxpayerAliasPath
    ];
  }

  static getTaxReturnAliasPaths() {
    return [
      defaultConfig.taxReturnAliasPath,
      dfamConfig.taxReturnAliasPath
    ];
  }
}
